import { useEffect, useState } from "react";
import Button from "../../../components/Button";
import { Input } from "../../../components/Input";
import { SettingCard } from "./SettingCard";

interface NumberSettingCardProps {
  title: string;
  description: string;
  value: number;
  onSave: (value: number) => Promise<void>;
}

export const NumberSettingCard = ({ title, description, value, onSave }: NumberSettingCardProps) => {
  const [draft, setDraft] = useState(String(value));
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    setDraft(String(value));
  }, [value]);

  const parsed = Number(draft);
  const isValid = draft.trim() !== "" && Number.isInteger(parsed) && parsed > 0;
  const isDirty = parsed !== value;

  const handleSave = async () => {
    if (!isValid || !isDirty) return;
    setIsSaving(true);
    try {
      await onSave(parsed);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <SettingCard title={title} description={description}>
      <div className="flex items-center gap-2">
        <div className="w-32">
          <Input value={draft} onChange={setDraft} placeholder={String(value)} />
        </div>
        <Button onClick={handleSave} disabled={!isValid || !isDirty} loading={isSaving}>
          Save
        </Button>
      </div>
      {!isValid && draft.trim() !== "" && (
        <p className="text-sm text-red-600 mt-1">Enter a positive whole number.</p>
      )}
    </SettingCard>
  );
};
